
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credittent/contact-us",
      function () {
        return require("private-next-pages/credittent/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credittent/contact-us"])
      });
    }
  